var o={top:{top:0}};export{o as legendWrapperStyleConfig};
